var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#4E3E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8572 -15.5184C94.8572 -15.5184 68.4786 -2.95593 73.1606 28.1212C78.4134 62.967 47.9524 77.9223 27.1408 69.308C6.32909 60.6639 7.78505 28.6895 -31.7828 27.7024C-72.2072 26.7154 -80.7145 -13.5443 -80.7145 -13.5443",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3677 -24.8806C64.3677 -24.8806 52.9484 1.68004 57.0308 28.0911C61.1417 54.5021 42.671 57.6128 35.3341 54.5021C20.0894 48.1013 17.1489 13.8237 -7.45971 11.6103C-25.959 9.93536 -50.8531 23.1857 -64.0424 -6.87439",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0634 -13.0358C52.0634 -13.0358 56.1743 14.0931 37.9891 9.24758C17.1488 3.68422 17.4629 -9.35679 -8.9157 2.96636C-18.3081 7.36322 -56.106 8.64937 -48.4836 -15.5184",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8741 45.1403C43.2415 45.1403 46.782 39.6766 46.782 32.9368C46.782 26.197 43.2415 20.7333 38.8741 20.7333C34.5067 20.7333 30.9662 26.197 30.9662 32.9368C30.9662 39.6766 34.5067 45.1403 38.8741 45.1403Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 10H61V60H11V10Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1469 51.7836L27.973 49.4679C28.7113 50.7767 29.3828 51.8841 30.9935 51.8841C32.5375 51.8841 33.5111 51.2802 33.5111 48.931V32.9548H38.2098V48.9974C38.2098 53.864 35.357 56.0793 31.1949 56.0793C27.4361 56.0793 25.2543 54.1326 24.1467 51.7832L24.1469 51.7836ZM40.7619 51.28L44.5877 49.065C45.5949 50.7097 46.9039 51.9179 49.2195 51.9179C51.1666 51.9179 52.408 50.9445 52.408 49.6019C52.408 47.991 51.1326 47.4203 48.9846 46.4808L47.8101 45.9769C44.4201 44.5341 42.1715 42.7216 42.1715 38.8955C42.1715 35.3713 44.8564 32.6861 49.0519 32.6861C52.0391 32.6861 54.1871 33.7267 55.7308 36.4453L52.0723 38.7949C51.2666 37.3517 50.3943 36.7812 49.0517 36.7812C47.6756 36.7812 46.8029 37.6539 46.8029 38.7949C46.8029 40.2045 47.6756 40.7754 49.6892 41.648L50.8639 42.1513C54.858 43.8632 57.1066 45.6084 57.1066 49.5349C57.1066 53.7642 53.784 56.0799 49.3201 56.0799C44.957 56.0799 42.1377 53.999 40.7617 51.2802",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -4,
    y: -1,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.8c5d2fa01a6d32fd4ccb54665e19aee6.svg";
export { ForwardRef as ReactComponent };